module.exports = __webpack_public_path__ + "assets/google_chrome.bb7b4a0a.png";